import { useQuery, UseQueryOptions } from 'react-query'
import client from '../../../api/client'
import { CategoryDetail } from '../../../types'
import { loadArticles } from '../utils'

const useTemplateCategories = (reactQueryOptions: UseQueryOptions<Awaited<ReturnType<typeof loadArticles>>[]> = {}) =>
  useQuery<Awaited<ReturnType<typeof loadArticles>>[]>(
    ['templates', 'categories'],
    async () => {
      const data = await client.getCategoriesForCreateFromTemplateModal()
      if (!data || !data.categories || !data?.categories?.length) return []

      return Promise.all(data.categories.map((category: CategoryDetail) => loadArticles(category))).then((cats) => {
        return cats.filter((cat: any) => cat.articles.length >= 1)
      })
    },
    reactQueryOptions,
  )

export default useTemplateCategories
